/** Safe .docx file name from the draft title, without doubling the extension. */
export const draftDownloadFilename = (title: string | undefined): string => {
  const sanitizedTitle = title
    ?.replace(/[\\/:*?"<>|]/g, '_')
    .trim()
    .replace(/\.docx$/i, '');

  return sanitizedTitle ? `${sanitizedTitle}.docx` : 'draft.docx';
};
